import { api } from "../../http";

async function GetDataAllMolde() {
  try {
    
    const data = await api.get(`/moldes`);
    return data;


  } catch (e) {
    console.log(e.message);
  }
}

export { GetDataAllMolde };
